(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 7639:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(82383);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZE": function() { return /* binding */ getJsonLd; }
});

// UNUSED EXPORTS: setJsonLdAccommodation, setJsonLdBreadcrumb, setSameAsByMarket

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./client/components/JsonLd/constants.js
var jsonld = {
    "@context": "https://schema.org",
    "@type": "Organization",
    address: {
        "@type": "PostalAddress",
        addressCountry: "ES",
        addressLocality: "Barcelona",
        addressRegion: "Barcelona",
        postalCode: "08010",
        streetAddress: "Ronda Sant Pere 17, 3\xba 4\xaa"
    },
    founders: [
        {
            "@type": "Person",
            name: "Luis Osorio Sol\xe9"
        },
        {
            "@type": "Person",
            name: "Francesc L\xf3pez Castellet"
        },
        {
            "@type": "Person",
            name: "Ra\xfal Mor\xf3n Sillero"
        }, 
    ],
    foundingDate: "2015-01-29",
    foundingLocation: "Barcelona",
    legalName: "Stayforlong S.L.",
    logo: {
        "@type": "ImageObject",
        caption: "Stayforlong logo",
        url: "https://static.stayforlong.com/web/images/sfl-logo-mobile.jpg"
    },
    name: "Stayforlong",
    url: "https://www.stayforlong.com"
};
var descriptions = {
    es: "Stayforlong es un sitio web de reservas hoteleras especializado en las reservas de larga estancia. Se encuentra presente en 22 pa\xedses distintos y ofrece a sus clientes una cartera formada por m\xe1s de 720.000 establecimientos hoteleros. Stayforlong tiene su sede en la ciudad de Barcelona.",
    de: "Stayforlong ist eine Hotelreservierungswebseite spezialisiert auf Langzeitaufenthalte. Wir sind pr\xe4sent in 22 verschiedenen L\xe4ndern und bieten unseren Kunden ein Portfolio von mehr als 720.000 Hotels. Stayforlong hat den Hauptsitz in Barcelona.",
    fr: "Stayforlong est un portail de r\xe9servation d'h\xf4tels sp\xe9cialis\xe9 dans les longs s\xe9jours.Nous sommes pr\xe9sents dans 22 pays et proposons \xe0 nos utilisateurs plus de 720.000 h\xf4tels diff\xe9rents.",
    uk: "Stayforlong is a hotel reservation portal specialized in long stays. We are present in 22 countries and offer to our clients more than 720.000 different hotels. Stayforlong's headquarter is located in Barcelona, Spain.",
    pt: "Stayforlong \xe9 um portal de reservas de hot\xe9is especializado em estadias longas. Estamos presentes em 22 pa\xedses e oferecemos aos nossos usu\xe1rios mais de 720.000 hot\xe9is diferentes."
};
var sameAs = [
    "https://www.facebook.com/stayforlong",
    "https://www.instagram.com/stayforlong",
    "https://www.youtube.com/channel/UCXY0iWptc19iyKlVqkK1ZGw", 
];

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
;// CONCATENATED MODULE: ./client/components/JsonLd/mappers.js

function setAddress(param) {
    var street = param.street, locality = param.locality, region = param.region, _country = param.country, country = _country === void 0 ? DEFAULT_COUNTRY.market : _country, postalCode = param.postalCode;
    return {
        "@type": "PostalAddress",
        streetAddress: street,
        addressLocality: locality,
        addressRegion: region,
        postalCode: postalCode,
        addressCountry: country
    };
}
var setAmenities = function(amenities) {
    return amenities.map(function(amenity) {
        return {
            "@type": "LocationFeatureSpecification",
            value: "True",
            name: amenity.name
        };
    });
};
var mappers_mapJsonLdTypeDetail = function(accommodation, addressParam) {
    var accommodationType = accommodation.accommodationType, name = accommodation.name, url = accommodation.url, image = accommodation.photo, description = accommodation.description, latitude = accommodation.latitude, longitude = accommodation.longitude, rating = accommodation.rating, facilities = accommodation.facilities;
    return {
        "@context": "http://schema.org",
        "@type": accommodationType.toLowerCase(),
        name: name,
        url: url,
        image: image,
        description: description,
        address: setAddress(addressParam),
        geo: {
            "@type": "GeoCoordinates",
            latitude: latitude,
            longitude: longitude
        },
        starRating: {
            "@type": "http://schema.org/Rating",
            ratingValue: rating
        },
        amenityFeature: setAmenities(facilities)
    };
};
var mappers_mapJsonLdBreadcrumb = function(param) {
    var urlHome = param.urlHome, urlList = param.urlList, urlDetail = param.urlDetail, listTitle = param.listTitle, detailTitle = param.detailTitle;
    return {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: urlHome
            },
            {
                "@type": "ListItem",
                position: 2,
                name: listTitle,
                item: urlList
            },
            {
                "@type": "ListItem",
                position: 3,
                name: detailTitle,
                item: urlDetail
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./client/components/JsonLd/utils.js





function setJsonLdBreadcrumb(params) {
    return JSON.stringify(mapJsonLdBreadcrumb(params));
}
function setJsonLdAccommodation(accommodation, addressParam) {
    return JSON.stringify(mapJsonLdTypeDetail(accommodation, addressParam));
}
function setSameAsByMarket(market) {
    var linkedinMarket = market !== "es" && market !== "de" && market !== "fr" && market !== "pt" ? "https://www.linkedin.com/company/stayforlong" : "https://".concat(market, ".linkedin.com/company/stayforlong");
    var twitterMarket = market === "es" ? "https://twitter.com/stayforlong_es" : "https://twitter.com/stayforlong";
    return (0,_to_consumable_array/* default */.Z)(sameAs).concat([
        linkedinMarket,
        twitterMarket
    ]);
}
function getJsonLd(market) {
    var jsonLdMarket = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonld), {
        sameAs: setSameAsByMarket(market)
    });
    if (!descriptions[market]) {
        return JSON.stringify(jsonLdMarket);
    }
    return JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonLdMarket), {
        description: descriptions[market]
    }));
}


/***/ }),

/***/ 77555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home_Head; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/constants/business.js
var business = __webpack_require__(17003);
// EXTERNAL MODULE: ./client/components/JsonLd/utils.js + 2 modules
var utils = __webpack_require__(59896);
// EXTERNAL MODULE: ./lib/utils/page.ts
var page = __webpack_require__(96011);
// EXTERNAL MODULE: ./src/comps/HrefLangs/index.js + 1 modules
var HrefLangs = __webpack_require__(15363);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./client/pages/Home/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    title: {
        id: "page.home.title"
    },
    description: {
        id: "page.home.description"
    },
    bannerText: {
        id: "banner.text"
    },
    bannerTitle: {
        id: "banner.title"
    },
    homeTitle: {
        id: "hero.best-hotels-for-your-holidays"
    }
});
/* harmony default export */ var Home_messages = (messages);

// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./client/pages/Home/Head.tsx










var Head = function(props) {
    var _pathname = props.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useMarket/* useMarket */.A)(), language = ref.language, market = ref.market, subdomain = ref.subdomain, topdomain = ref.topdomain;
    var title = "".concat(business/* BRAND_NAME_TITLE */.W_, ": ").concat(intl.formatMessage(Home_messages.title));
    var description = intl.formatMessage(Home_messages.description, {
        brand: business/* BRAND_NAME_TITLE */.W_
    });
    var canonicalURL = (0,page/* buildCanonicalURL */._L)({
        market: market,
        language: language,
        pathname: pathname,
        subdomain: subdomain,
        topdomain: topdomain
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: (0,utils/* getJsonLd */.ZE)(market)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangs/* default */.Z, {
                pathname: pathname
            })
        ]
    });
};
/* harmony default export */ var Home_Head = (Head);


/***/ }),

/***/ 82383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   "pageId": function() { return /* binding */ pageId; },
/* harmony export */   "pagePathView": function() { return /* binding */ pagePathView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var src_pages_builder_simplePage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61381);





var pagePathView = "/privacy";
var pageId = "privacy";
var __N_SSP = true;

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_pages_builder_simplePage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        pageId: pageId
    }));
};


/***/ }),

/***/ 15363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_HrefLangs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
;// CONCATENATED MODULE: ./lib/domain.js

function buildHref(param) {
    var country = param.country, _pathname = param.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var subDomain = country.subdomain || "www";
    var topDomain = country.topdomain || "com";
    var queryParams = !country.subdomain && !country.topdomain ? "?market=".concat(country.market, "&lang=").concat(country.language) : "";
    return "https://".concat(subDomain, ".").concat(environment/* DOMAIN */.yK, ".").concat(topDomain).concat(pathname).concat(queryParams);
}

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
// EXTERNAL MODULE: ./client/components/CountrySelector/index.tsx + 2 modules
var CountrySelector = __webpack_require__(59813);
;// CONCATENATED MODULE: ./src/comps/HrefLangs/index.js







var HrefLangs = function(param) {
    var pathname = param.pathname;
    var hrefDefault = buildHref({
        country: countries/* DEFAULT_COUNTRY */.U,
        pathname: pathname
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                hrefLang: "x-default",
                href: hrefDefault
            }),
            Object.keys(countries/* COUNTRIES */.o).filter(function(key) {
                return key !== "zz" && !CountrySelector/* NEW_MARKETS.includes */.p.includes(key);
            }).map(function(key) {
                var country = countries/* COUNTRIES */.o[key];
                var href = buildHref({
                    country: country,
                    pathname: pathname
                });
                var hrefLang = countries/* COUNTRIES */.o[key].market === "no" ? "no" : country.locale;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    hrefLang: hrefLang,
                    href: href
                }, key);
            })
        ]
    });
};
HrefLangs.propTypes = {
    pathname: (prop_types_default()).string.isRequired
};
/* harmony default export */ var comps_HrefLangs = (HrefLangs);


/***/ }),

/***/ 61381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pagePathView */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96204);
/* harmony import */ var client_components_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3066);
/* harmony import */ var src_comps_Page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77288);
/* harmony import */ var client_components_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56411);
/* harmony import */ var client_pages_Home_Head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77555);
/* harmony import */ var _s4l_stayforlong_booking_ListOfAncillary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49579);








var pagePathView = "/reviews";

var SimplePage = function(props) {
    var config = props.config, builderContent = props.builderContent, pageId = props.pageId;
    var locale = config.locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_comps_Page__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        config: config,
        pageId: pageId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_pages_Home_Head__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                pageId: pageId,
                ancillariesJSON: _s4l_stayforlong_booking_ListOfAncillary__WEBPACK_IMPORTED_MODULE_7__/* .ListOfAncillary.empty */ .N.empty().toJSON()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .BuilderComponent */ .VD, {
                locale: locale,
                model: "page",
                content: builderContent
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimplePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7639); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);